import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { BLOG_CATEGORIES } from '@/lib/blogCategories';

interface BlogCategoryFilterProps {
  activeSlug?: string;
}

const pill = 'rounded-full border px-4 py-2 text-sm font-semibold transition-all';
const active = 'border-transparent bg-bv-ink text-white shadow-bv-card';
const idle = 'border-bv-blue-line bg-white text-bv-ink2 hover:-translate-y-0.5 hover:border-bv-blue/40 hover:text-bv-ink';

export function BlogCategoryFilter({ activeSlug }: BlogCategoryFilterProps) {
  return (
    <nav aria-label="Blog categories" className="flex flex-wrap justify-center gap-2">
      <Link to="/blog" aria-current={!activeSlug ? 'page' : undefined} className={cn(pill, !activeSlug ? active : idle)}>All</Link>
      {BLOG_CATEGORIES.map(cat => (
        <Link key={cat.slug} to={`/blog/${cat.slug}`} aria-current={activeSlug === cat.slug ? 'page' : undefined} className={cn(pill, activeSlug === cat.slug ? active : idle)}>{cat.name}</Link>
      ))}
    </nav>
  );
}
